import styled from '@emotion/styled';
import VerticalMoveIcon from 'src/assets/icons/VerticalMoveIcon';

export const MarketTemplateList = styled('ul', { label: 'MarketTemplateList' })`
    list-style-type: none;
    margin: 0;
    overflow-y: scroll;
    padding: 0;
`;

export const MarketTemplateListItem = styled('li', { label: 'MarketTemplateListItem' }) <{isDragged: boolean}>`
    background-color: #eee;
    border: 1px solid rgba(0, 0, 0, .2);
    color: #333;
    font-size: 0.5rem;
    padding: 8px 10px;
    width: 100%;
    z-index: ${({ isDragged }): string => isDragged ? '10002' : 'inherit'};
    &:hover,
    &:focus {
        background: #f3f3f3;
    }
`;

// ForItem
export const ItemButton = styled('span', { label: 'ItemButton' }) <{isDragged: boolean}>`
    cursor: ${({ isDragged }): string => isDragged ? 'grabbing' : 'grab'};
    position: absolute;
    padding: 30px 10px 30px;
    right: 0px;
    top: -2px;
`;
export const ItemWrapper = styled('div', { label: 'ItemWrapper' })`
    display: grid;
    grid-template-columns: auto 50px 20px;
    grid-template-rows: 40px auto;
`;

export const DraggerWrapper = styled('div', { label: 'DraggerWrapper' })`
    grid-column-start: 3;
    position: relative;
    width: 30px;
`;

export const InputSelection = styled('input', { label: 'InputSelection' })`
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 3px;
    box-shadow: inset 0 3px 5px 0 rgba(0, 0, 0, 0.03);
    color: #2b2b2b;
    font-size: 1em;
    font-weight: 600;
    height: 3em;
    line-height: 3em;
    outline: none;
    padding: 0 12px;
    width: 100%;
`;

export const InputWrapper = styled('div', { label: 'InputWrapper' })`
    grid-column-start: 1;
    grid-column-end: 2;
`;

export const TemplateOptionsDropDown = styled('div', { label: 'TemplateOptionsDropDown' })`
    grid-column-start: 2;
    grid-column-end: 3;
    padding: 4px;
`;

export const MarketTemplateSelectionForm = styled('div', { label: 'MarketTemplateSelectionForm' })`
    background: #fff;
    grid-column-start: 1;
    grid-column-end: 4;
    grid-row-start: row2-start;
    margin: 8px 0px -8px;
    padding: 8px;
`;

export const VerticalMoveIconWrapper = styled(VerticalMoveIcon, { label: 'VerticalMoveIconWrapper' })`
    position: absolute;
    right: 10px;
    top: 13px;
`;
